import React from 'react';
import { Switch } from 'react-router-dom';
import ConditionalRoute from 'components/ServiceDisabledInfo/ConditionalRoute';
import { USER_ROLE_SUPERVISIOR } from 'lib/util';
import permissionService from 'services/permission.service';
import Account from '../Account';
import AdditionalTab from 'containers/AdditionalTab/AdditionalTab';
import Admin from '../Admin';
import ChangePassword from '../Account/ChangePassword';
import CookiePolicy from '../CookiePolicy';
import ISOD from '../ISOD';
import News from '../News';
import NewOrder from '../NewOrder';
import Orders from '../Orders';
import Promotions from '../Promotions';
import Settings from 'containers/Settings/Settings';
import Settlements from '../Settlements';
import UrlExpired from 'containers/UrlExpired';

interface IAppRoutesProps {
    isDisabled: boolean;
    disableTime: string;
    disableMessage: string;
    isPhone: boolean;
    isISODVisible: string;
    cartReset: boolean;
    setCartReset: React.Dispatch<React.SetStateAction<boolean>>;
    user: any;
}

const AppRoutes = ({
    isDisabled,
    disableTime,
    disableMessage,
    isPhone,
    isISODVisible,
    cartReset,
    setCartReset,
    user
}: IAppRoutesProps) => {
    const sharedRouteProps = {
        isOrdersServiceDisabled: isDisabled,
        disableTime,
        disableMessage
    };

    const routes = [
        {
            name: 'orders',
            path: `${process.env.PUBLIC_URL}/orders/:page`,
            viewVisibilityCondition: permissionService.haveAccessToView('orders'),
            view: <Orders />
        },
        {
            name: 'orders',
            path: `${process.env.PUBLIC_URL}/orders`,
            viewVisibilityCondition: permissionService.haveAccessToView('orders'),
            view: <Orders />
        },
        {
            name: 'new-order',
            path: `${process.env.PUBLIC_URL}/new-order`,
            viewVisibilityCondition: permissionService.haveAccessToView('new-order'),
            view: <NewOrder cartReset={cartReset} setCartReset={setCartReset} />
        },
        {
            name: 'settlements',
            path: `${process.env.PUBLIC_URL}/settlements/:page`,
            viewVisibilityCondition: permissionService.haveAccessToView('settlements'),
            view: <Settlements />
        },
        {
            name: 'settlements',
            path: `${process.env.PUBLIC_URL}/settlements`,
            viewVisibilityCondition: permissionService.haveAccessToView('settlements'),
            view: <Settlements />
        },
        {
            name: 'promotions',
            path: `${process.env.PUBLIC_URL}/promotions`,
            viewVisibilityCondition: permissionService.haveAccessToView('promotions'),
            view: <Promotions />
        },
        {
            name: 'isod',
            path: `${process.env.PUBLIC_URL}/isod`,
            viewVisibilityCondition: permissionService.haveAccessToView('isod') && !isPhone,
            view: <ISOD visibility={isISODVisible} isOrdersServiceDisabled={isDisabled} />
        },
        {
            name: 'account',
            path: `${process.env.PUBLIC_URL}/account`,
            viewVisibilityCondition: permissionService.haveAccessToView('account'),
            view: <Account />
        },
        {
            name: 'cookie-policy',
            path: `${process.env.PUBLIC_URL}/cookie-policy`,
            viewVisibilityCondition: permissionService.haveAccessToView('cookie-policy'),
            view: <CookiePolicy />
        },
        {
            name: 'news',
            path: `${process.env.PUBLIC_URL}/news/:page`,
            viewVisibilityCondition: permissionService.haveAccessToView('news'),
            view: <News />
        },
        {
            name: 'news',
            path: `${process.env.PUBLIC_URL}/news/edit/:id`,
            viewVisibilityCondition: permissionService.haveAccessToView('news'),
            view: <News />
        },
        {
            name: 'news',
            path: `${process.env.PUBLIC_URL}/news`,
            viewVisibilityCondition: permissionService.haveAccessToView('news'),
            view: <News />
        },
        {
            name: 'changePassword',
            path: `${process.env.PUBLIC_URL}/changePassword`,
            viewVisibilityCondition: permissionService.haveAccessToView('changePassword'),
            view: <ChangePassword />
        },
        {
            name: 'admin',
            path: `${process.env.PUBLIC_URL}/admin`,
            viewVisibilityCondition: permissionService.haveAccessToView('admin'),
            view: <Admin />
        },
        {
            name: 'additional-tab',
            path: `${process.env.PUBLIC_URL}/additional-tab`,
            viewVisibilityCondition: permissionService.haveAccessToView('additional-tab'),
            view: <AdditionalTab />
        },
        {
            name: 'settings',
            path: `${process.env.PUBLIC_URL}/settings`,
            viewVisibilityCondition: permissionService.haveAccessToView('settings'),
            view: <Settings />
        },
        {
            name: 'urlExpired',
            path: `${process.env.PUBLIC_URL}/expired-url`,
            viewVisibilityCondition: true,
            view: <UrlExpired />
        },
        {
            name: 'default',
            viewVisibilityCondition: true,
            view: user?.role === USER_ROLE_SUPERVISIOR ? <Orders /> : (permissionService.haveAccessToView('news') ? <News /> : <Promotions />)
        }
    ];

    return (
        <Switch>
            {routes.map((route, index) => (
                <ConditionalRoute
                    key={`${route.name}-${route.path || 'default'}-${index}`}
                    name={route.name}
                    path={route.path}
                    viewVisibilityCondition={route.viewVisibilityCondition}
                    view={route.view}
                    {...sharedRouteProps}
                />
            ))}
        </Switch>
    );
};

export default AppRoutes;
